<script setup>
import { ref, onMounted } from 'vue'
import { GltfModel, Box, Camera, AmbientLight, LambertMaterial, PointLight, Renderer, Scene } from 'troisjs'
const rendererC = ref()
const meshC = ref()

const props = defineProps({
    src: String
})

onMounted(() => {
    // const renderer = rendererC.value
    // const mesh = meshC.value.mesh
    // renderer.onBeforeRender(() => {
    //     mesh.rotation.x += 0.01
    // })
})

function onError(err) {
    console.log("webgl-component[error]: ", err);
}
function onReady(model) {
    console.log("webgl-component[load]: ", model);
}
function onProgress(progress) {
    // console.log("webgl-component: ", progress);
}
</script>

<template>
    <!-- <Renderer ref="rendererC" antialias :orbit-ctrl="{ enableDamping: true }" resize="window">
        <Camera :position="{ z: 10 }" />
        <Scene>
            <AmbientLight />
            <PointLight :position="{ y: 50, z: 50 }" intensity="10" />

            <Box :size="1" ref="meshC" :rotation="{ y: Math.PI / 4, z: Math.PI / 4 }">
                <LambertMaterial />
            </Box>


            <GltfModel
                :position="{ y: 50, z: 50 }"
                :visible="true"

                @error="onError"
                @load="onReady"
                @progress="onProgress"
                src="/fonts/Earth_1_12756.glb"
            />
            <GltfModel
                :position="{ y: 50, z: 50 }"
                :visible="true"

                @error="onError"
                @load="onReady"
                @progress="onProgress"
                src="/fonts/sgdtnt.gltf"
            />
        </Scene>
    </Renderer> -->
    <Renderer
        :orbit-ctrl="{
            enableDamping: true,
            autoRotate: true,
            autoRotateSpeed: 0.25,
            rotateSpeed: 0.5,
            enableZoom: true,
        }"
        width="1920"
        height="1080"

        antialias
        ref="renderer"
        resize="true"
    >
        <Camera :position="{ x: 1200, y: 0, z: 0 }" />
        <Scene>
            <AmbientLight intensity="1"></AmbientLight>
            <Box :size="1" ref="meshC" :rotation="{ y: Math.PI / 4, z: Math.PI / 4 }">
                <LambertMaterial />
            </Box>
            <GltfModel
                :position="{ x: 0, y: 0, z: 0 }"
                :scale="{ x: 1, y: 1, z: 1 }"
                :src="src"
            />
        </Scene>
    </Renderer>

</template>


<style>
canvas {
    display: block;
    width: 100%;
}
</style>
